// extracted by mini-css-extract-plugin
module.exports = {"hand":"FingerTouchIcon_hand__fZM01","strong":"FingerTouchIcon_strong__XLkjn","shaking":"FingerTouchIcon_shaking__2J7jA"};